export const authFieldShellLabelRowSx = {
  alignItems: 'center',
  columnGap: '12px',
  display: 'flex',
  justifyContent: 'flex-start',
  minWidth: 0,
  overflow: 'hidden',
  width: '100%',
} as const;

export const authFieldShellLabelSx = {
  cursor: 'pointer',
  display: 'block',
  flexShrink: 0,
  margin: 0,
  minWidth: 0,
  whiteSpace: 'nowrap',
} as const;
